// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CommandSquareIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "CommandSquare/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.492 1.667H6.508c-3.033 0-4.841 1.808-4.841 4.841v6.975c0 3.042 1.808 4.85 4.841 4.85h6.975c3.034 0 4.842-1.808 4.842-4.841V6.508c.008-3.033-1.8-4.841-4.833-4.841ZM8 13.5c0 .825-.675 1.5-1.5 1.5S5 14.325 5 13.5 5.675 12 6.5 12h.667c.458 0 .833.375.833.833v.667Zm0-6.333A.836.836 0 0 1 7.167 8H6.5C5.675 8 5 7.325 5 6.5S5.675 5 6.5 5 8 5.675 8 6.5v.667Zm3.792 3.875c0 .408-.334.75-.75.75H8.95a.752.752 0 0 1-.75-.75V8.95c0-.408.333-.75.75-.75h2.092c.408 0 .75.333.75.75v2.092ZM13.5 15c-.825 0-1.5-.675-1.5-1.5v-.667c0-.458.375-.833.833-.833h.667c.825 0 1.5.675 1.5 1.5s-.675 1.5-1.5 1.5Zm0-7h-.667A.836.836 0 0 1 12 7.167V6.5c0-.825.675-1.5 1.5-1.5s1.5.675 1.5 1.5S14.325 8 13.5 8Z"
}));
export default CommandSquareIcon;